import React, { FC, useState } from 'react';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { Auth } from '../../helpers/Auth';
import { useLocation, useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ResetPassword: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  const resetPassword = () => {
    const code = new URLSearchParams(location.search).get('code') || '';
    Auth.resetPassword(code, password, passwordConfirmation)
      .then(() => {
        navigate('/signin');
      })
      .catch((reason) => {
        enqueueSnackbar(reason.response.data.message[0].messages[0].message || 'Errore nella richiesta.', {
          variant: 'error',
        });
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Reimposta password
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            onChange={(event) => setPassword(event.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password-confirmation"
            label="Conferma password"
            type="password"
            onChange={(event) => setPasswordConfirmation(event.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => resetPassword()}
          >
            Reimposta password
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default ResetPassword;
